import PropTypes from 'prop-types';
import style from './TagList.module.less';
import UrlBuilder from '../../utils/UrlBuilder';
import ReloadHelper from '../../utils/ReloadHelper';
import Translations from '../../utils/Translations';
import TagSuggest from '../TagSuggestion/TagSuggest';
import withMobileViewChange from '../HigherOrderComponents/Utility/withMobileViewChange';
import { useEffect, useState } from 'react';

const itemHeight = 36;

function onVip30Click(e) {
	ReloadHelper.reload(UrlBuilder.buildVIP30Url(), e);
}

function handleOnTagClick(tag, actorName, e) {
	const url = UrlBuilder.buildActorProfileVideosUrl(actorName) + '?tag=' + tag;
	ReloadHelper.reload(url, e);
}

let listRef = null;

const TagList = (props) => {
	const { album } = props;
	if (!album.isVip30 && album.displayTags.length === 0) {
		return null;
	}

	useEffect(
		() => () => {
			listRef = null;
		},
		[],
	);

	const [hide, setHide] = useState(false);
	const [needCollapse, setNeedCollapse] = useState(false);
	const [showTagSuggest, setShowTagSuggest] = useState(false);

	const tags = album.displayTags;
	const showSuggest = album.isBought && !album.needBuying;

	const setListRef = (ref) => {
		if (!listRef) {
			listRef = ref;
			const listWidth = listRef?.clientWidth;
			const wrapperWidth = listRef.parentElement?.getBoundingClientRect().width;
			if (listWidth > wrapperWidth - (showSuggest ? 160 : 50)) {
				setHide(true);
				setNeedCollapse(true);
			}
		}
	};

	const itemStyle = { height: itemHeight + 'px', borderRadius: itemHeight / 2 + 'px' };

	return (
		<section className={style['tag-list__wrapper']}>
			<h3 className={style['tag-list__headline']}>
				{Translations.get('Tags')}{' '}
				{needCollapse && (
					<i
						className={`icon -icon-single-arrow-up-line ${style['tag-list__arrow']} ${hide ? style['tag-list__arrow--down'] : ''}`}
						onClick={() => setHide(!hide)}
					/>
				)}
			</h3>
			<div className={style['tag-list__container']}>
				<ul className={style['tag-list']} ref={(ref) => setListRef(ref)} style={hide ? { height: itemHeight + 'px' } : {}}>
					{album.isVip30 && (
						<li className={`${style['tag-list__item']} ${style['tag-list__item--vip']}`} style={itemStyle}>
							<a
								href={UrlBuilder.buildVIP30Url()}
								onClick={onVip30Click}
								dangerouslySetInnerHTML={{ __html: Translations.get('VIP30TAG') }}
							/>
						</li>
					)}
					{tags.length > 0 &&
						tags.map((tag) => (
							<li key={tag} className={style['tag-list__item']} style={itemStyle}>
								<a
									className={'h-color-inherit'}
									href={UrlBuilder.buildActorProfileVideosUrl(album.actor.name) + '?tag=' + tag}
									onClick={(e) => handleOnTagClick(tag, album.actor.name, e)}
								>
									{tag}
								</a>
							</li>
						))}
				</ul>
				{showSuggest && (hide || !needCollapse) && (
					<div
						className="actor-pictures__tag__text--footer"
						style={{ fontSize: '14px', display: 'flex', marginLeft: '10px' }}
						onClick={() => setShowTagSuggest(!showTagSuggest)}
					>
						<div style={{ width: 'max-content' }} className="h-cursor-pointer">
							{Translations.get('addTag')}
						</div>
						<img
							className="actor-pictures__tag__text--footer--icon h-cursor-pointer"
							src="/assets/img/plus-full.svg"
							style={{ marginLeft: '10px' }}
						/>
					</div>
				)}
			</div>
			{showSuggest && !hide && needCollapse && (
				<div
					className="actor-pictures__tag__text--footer"
					style={{ fontSize: '14px', padding: '20px 0 10px 0' }}
					onClick={() => setShowTagSuggest(!showTagSuggest)}
				>
					<span className="h-cursor-pointer">{Translations.get('addTag')}</span>
					<img
						className="actor-pictures__tag__text--footer--icon h-cursor-pointer"
						src="/assets/img/plus-full.svg"
						style={{ marginLeft: '10px' }}
					/>
				</div>
			)}
			{showSuggest && (
				<div className="profile-video-details--description-tags-suggest">{showTagSuggest && <TagSuggest albumId={album.id} />}</div>
			)}
		</section>
	);
};

TagList.propTypes = {
	album: PropTypes.object,
	isMobileView: PropTypes.bool,
};

export default withMobileViewChange(TagList);
